import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import { fetchProjectTitles } from '../../actions/project_actions';
import { titleOptionsForDivision } from '../../utils/team';
import { MdEdit, MdDelete } from 'react-icons/lib/md';
import { FieldLike } from './utils';

class MemberForm extends React.Component {
    constructor(props) {
        super(props);

        const { projectTitleId } = props.teamObj;

        this.state = {
            projectTitleId,
            editEmail: false,
            email: props.teamObj.member.email
        }

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleTitleChange = this.handleTitleChange.bind(this);
        this.handleEditEmail = this.handleEditEmail.bind(this);
        this.handleEmailChange = this.handleEmailChange.bind(this);
    }

    UNSAFE_componentWillMount() {
        const { projectTitles } = this.props;
        if (projectTitles.length === 0) this.props.fetchProjectTitles();
    }

    getTitleOptions() {
        const { projectTitles, divisionName, groupName } = this.props;
        const { member } = this.props.teamObj;

        const CT_TITLES = [
            9152, //CM PM
            9159, //CM Executive
            9128, //Construction RE
            9129  //Construction OE
        ];

        let titleOptions = titleOptionsForDivision(projectTitles, divisionName, groupName);

        if (member.email.substring(0, 2).toUpperCase() === 'CT' || member.email.toUpperCase().indexOf('@ddc.nyc.gov'.toUpperCase()) < 0) {
            titleOptions = titleOptions.filter(({ label, value }) => {
                return CT_TITLES.includes(value);
            })
        }

        return titleOptions;
    }

    handleTitleChange(option) {
        const projectTitleId = option ? option.value : '';
        this.setState({ projectTitleId });
    }

    handleSubmit(e) {
        const { projectTitleId } = this.state;
        e.preventDefault();
        if (!projectTitleId) return;
        this.props.onSave({
            ...this.props.teamObj,
            projectTitleId,
            email: this.state.email
        });
    }

    handleEditEmail() {
        this.setState({ editEmail: true })
    }

    handleEmailChange(e) {
        this.setState({ email: e.target.value });
        e.preventDefault();

    }

    render() {
        const { member } = this.props.teamObj;
        let canSubmit = this.state.projectTitleId;

        return (
            <form onSubmit={this.handleSubmit}>
                <div className="member-details two-cols">
                    <div className="control">
                        <label>Employee ID</label>
                        <span>{member.employeeId}</span>
                    </div>
                    <div className="control">
                        <label>Email</label>
                        {!this.state.editEmail && <span>{member.email}
                            {(member.aD_MboxFlag == null || !member.aD_MboxFlag) && <span><MdEdit size={22} color='#8492a6' onClick={this.handleEditEmail} /></span>}
                        </span>}
                        {this.state.editEmail && <input type="text" value={this.state.email} onChange={this.handleEmailChange} />}
                    </div>
                </div>
                <div className="member-details two-cols">
                    <div className="control">
                        <label>Login ID</label>
                        <span>{member.loginId}</span>
                    </div>
                </div>
                <div className="member-details two-cols">
                    <div className="control">
                        <label>Unit name</label>
                        <span>{member.unitName}</span>
                    </div>
                    <div className="control">
                        <label>Section</label>
                        <span>{member.section}</span>
                    </div>
                </div>

                <div className="control required">
                    <label>Title</label>
                    <Select name="documentType"
                        value={this.state.projectTitleId}
                        options={this.getTitleOptions()}
                        onChange={this.handleTitleChange}
                    />
                </div>
                <button className="btn-update" disabled={!canSubmit}>
                    {this.props.teamObj.id ? 'Save' : 'Add member'}
                </button>
            </form>
        )
    }
}

MemberForm.propTypes = {
    teamObj: PropTypes.object.isRequired,
    onSave: PropTypes.func.isRequired,
    divisionName: PropTypes.string.isRequired,
    groupName: PropTypes.number.isRequired,
    projectTitles: PropTypes.array.isRequired,
    fetchProjectTitles: PropTypes.func.isRequired
};

function mapStateToProps(state) {
    return {
        projectTitles: state.projectsStore.projectTitles,
        divisionName: state.projectsStore.divisionName,
        groupName: 1,
    };
}

export default connect(mapStateToProps, { fetchProjectTitles })(MemberForm);